import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const JoinMeeting = (store) => ({
  path: ROUTE.JOIN_MEETING,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'joinMeeting',
    loadReducer: () => import('./JoinMeetingState'),
    loadComponent: () => import('./JoinMeetingContainer'),
  })
})

export default JoinMeeting
